import { render, staticRenderFns } from "./DT_ReleaseNotes.vue?vue&type=template&id=79c76a24&"
import script from "./DT_ReleaseNotes.vue?vue&type=script&lang=js&"
export * from "./DT_ReleaseNotes.vue?vue&type=script&lang=js&"
import style0 from "./DT_ReleaseNotes.vue?vue&type=style&index=0&id=79c76a24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports